import { useDispatch, useSelector } from 'react-redux';
import { Search, SearchIconWrapper, StyledInputBase } from 'components';
import { Tooltip, IconButton } from 'components/mui';
import { SearchIcon, CloseOutlinedIcon } from 'components/icons';
import { filterUsers } from 'containers/pages/users/libs';
import { selectAllUsers } from 'redux/users/usersSlice';
import { selectSearchKeyword } from 'redux/userMgt/userMgtSlice';
import {
	storeSearchedUsers,
	storeSearchKeyword,
} from 'redux/userMgt/userMgtSlice';

/**
 * @component UsersSearch
 * @returns {JSX.Element}
 */
function UsersSearch() {
	const dispatch = useDispatch();
	const searchKeyword = useSelector(selectSearchKeyword);
	const { users } = useSelector(selectAllUsers);

	const onInput = (e) => {
		dispatch(storeSearchKeyword(e.target.value));
		const _users = filterUsers(e.target.value, users);
		dispatch(storeSearchedUsers(_users));
	};

	const onReset = () => {
		dispatch(storeSearchKeyword(''));
		dispatch(storeSearchedUsers(users));
	};

	return (
		<Search>
			<SearchIconWrapper>
				<SearchIcon />
			</SearchIconWrapper>
			<StyledInputBase
				placeholder="Search…"
				value={searchKeyword}
				onChange={onInput}
				endAdornment={
					<Tooltip title="Clear">
						<IconButton onClick={onReset}>
							<CloseOutlinedIcon />
						</IconButton>
					</Tooltip>
				}
			/>
		</Search>
	);
}

export default UsersSearch;
